exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog--fullscreen{overflow-y:hidden!important}.v-dialog--fullscreen .v-card{height:100%}.v-dialog--fullscreen .v-card .embed-protocollo{margin-top:-50px;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/ProtocolloAnteprima.vue?vue&type=style&index=0&lang=scss&
// module id = 884
// module chunks = 0